export * from '@primeuix/themes/material/dock';
export { default } from '@primeuix/themes/material/dock';
